<script lang="ts">
  import {getContext} from 'svelte';
  import {goto} from '@sapper/app';
  import {fixLink$} from '@/store';
  import {PATHS} from '@/const';
  import {envUtil, numUtil} from '@/helper';
  import {isLogin$} from '@/streams/auth'
  import {userInfo$} from '@/store/user'
  import {isIpPreRestricted$, isIpRestricted$} from '@/modules/components/ip-restricted/streams';
  import {isExpired$} from '@/modules/bonus/rewards-hub/stream';
  import {is_JP_KR$, kycSummary$, getAllKycSummary, isKolWhiteListChannel$} from '@/modules/account/overview/stream-kyc';
  import {welcomeBonusAmount$} from '@/modules/bonus/rewards-hub/stream';
  import {isUnverifed$, expiredRemainingText$} from './stream';
  import lang from './NewbieRewardsAlert.lang';

  const LG = getContext('LG');

  let rewardsAlert = null;
  let wardsPlaceHeight = 0;
  let ipPlaceHeight = 0;
  let isOver24Hours = false;

  $: $isLogin$ && getAllKycSummary()
  $: ipShow = $isIpPreRestricted$ || $isIpRestricted$;
  $: isAdanceKyc = $kycSummary$.kycFlag === 1;

  // 计算24小时是否超过
  function calcOver24Hours() {
    const lastcloseTime = window.localStorage.getItem('WELCOME_LAST_CLOSE_TIME');
    const now = Date.now();
    if (lastcloseTime) {
      return Number(lastcloseTime) < now - 24 * 60 * 60 * 1000;
    }
    return true;
  }

  // 奖励时间24小时后显示，
  function handleAlertClose() {
    window.localStorage.setItem('WELCOME_LAST_CLOSE_TIME', Date.now().toString());
    isOver24Hours = false;
    const headerDom = document.querySelector('.header') as HTMLElement;
    if (headerDom) {
      headerDom.style.top = '1px';
    }
  }

  function gotoTargetUrl() {
    if ($isExpired$) {
      return goto($fixLink$(PATHS.ACCOUNT_VERIFICATION.pathname));
    }
    return goto($fixLink$(PATHS.BONUS.pathname) + '?tab=package');
  }

  function contentLoaded() {
    // 是否超过24小时
    isOver24Hours = calcOver24Hours();

    // header导航不要被挡住
    let timer = setTimeout(() => {
      if (isOver24Hours && $isUnverifed$ && isAdanceKyc && $userInfo$.isMain && !$is_JP_KR$ && !$isKolWhiteListChannel$) {
        const ipDom = ipShow ? document.querySelector('.ip-restricted-notify') : null;
        const headerDom = document.querySelector(envUtil.isMobile || envUtil.isApp ? '.header-h5' : '.header') as HTMLElement;
        // 当前奖励占位高度
        wardsPlaceHeight = Math.floor(rewardsAlert?.getBoundingClientRect().height || 0);
        // ip显示占位高度
        ipPlaceHeight = Math.floor(ipDom?.getBoundingClientRect().height || 0);
        if (rewardsAlert) {
          rewardsAlert.style.visibility = 'visible';
        }
        if (headerDom) {
          headerDom.style.top = `${ipPlaceHeight + wardsPlaceHeight}px`;
        }
      }
      clearTimeout(timer)
      timer = null
    }, 1000);
  }
</script>

<style lang="scss">
  .placeholder-block {
    transition: min-height 0.3s ease;
  }
  .newbie-rewards-alert {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: auto;
    background: #fff;
    visibility: hidden;
    .gap-4 {
      gap: 4px;
    }
    .gap-12 {
      gap: 12px;
    }
    .bg-danger {
      background: #f24e53;
    }
    .alert-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 10px 40px;
      width: 100%;
      background: rgba(242, 78, 83, 0.08);
      .alert-countdown {
        border-radius: 8px 8px 8px 0;
        padding: 4px 8px;
      }
    }
    .vas {
      vertical-align: sub;
    }
    .close-icon,
    .alert-wrapper-inner {
      &:hover {
        opacity: 0.8;
      }
    }
  }
  @media screen and (max-width: 640px) {
    .newbie-rewards-alert {
      .alert-wrapper {
        padding: 8px 20px;
      }
    }
  }
</style>

<svelte:window  on:load={contentLoaded}/>
<!--未完成Advance kyc，且非日韩用户且非特定渠道-->
{#if isOver24Hours && $isUnverifed$ && isAdanceKyc && $userInfo$.isMain && !$is_JP_KR$ && !$isKolWhiteListChannel$}
  <div class="placeholder-block" style="min-height: {wardsPlaceHeight}px" />
  <div class="newbie-rewards-alert" bind:this={rewardsAlert} style="top: {ipPlaceHeight}px">
    <div class="alert-wrapper gap-12">
      <div class="f1 df aic gap-4 cp alert-wrapper-inner" on:click={gotoTargetUrl}>
        <img src="https://img.phemex.com/v1/1e8ffbfb-85d9-4470-8ac7-c214907facca/error-info.png" alt="error-icon" width="20" height="20" />
        <div class="f1">
          {#if $isExpired$}
            <span class="fw1 f14 down">{LG(lang.ExpiredWelcomText)}</span>
          {:else}
            <span class="fw1 f14 down">{@html LG(lang.PeriodWelcomText, {Awards: `<span><span>$</span>${numUtil.delimit($welcomeBonusAmount$ || 0)}</span>`})}</span>
            <div class="dif aic gap-4 bg-danger TW fw2 f12 alert-countdown">
              <img src="https://img.phemex.com/v1/4cba3289-2f4b-4c94-a21f-3182fcea9ff5/countdown-clock.png" alt="clock-icon" width="12" height="12" />
              {$expiredRemainingText$}
            </div>
          {/if}
          <img class="vas" src="https://img.phemex.com/v1/b609d3ca-c68d-44ca-bfc3-7996c007d183/goto-right.png" alt="right-icon" width="16" height="16" />
        </div>
      </div>
      <img class="close-icon cp" src="https://img.phemex.com/v1/4b6ee9c7-129c-4241-955a-20be98c143eb/close.png" alt="close icon" width="20" height="20" on:click={handleAlertClose} />
    </div>
  </div>
{/if}
